import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSliders } from "@fortawesome/free-solid-svg-icons";

import { IconComponent } from "./types";

export const SettingsIcon: IconComponent = (props) => {
  return <FontAwesomeIcon {...props} icon={faSliders} color="#5a5c60" />;
};
